import { BaseState } from "slices";
import { XGSSelectOption } from "ui-components/xgs-select/xgsSelect";

export default interface ZipcodeLocationsState extends BaseState {
  locations: XGSSelectOption[];
}

export const initialZipcodeLocationsState: ZipcodeLocationsState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  locations: []
};
